export default "__VITE_ASSET__iHL_Halt__"